import { ReactGAImplementation } from 'react-ga4';

// react-ga4's default export is a CJS singleton that breaks under Rolldown's
// __toESM(mod, 1) force-wrapping in production builds. The named export
// ReactGAImplementation is the GA4 class which imports correctly.
// We create a single shared instance used by all consumers.
const ga4 = new ReactGAImplementation();

export default ga4;
